import { render } from "./invoices-edit.vue?vue&type=template&id=0f23b75e"
import script from "./invoices-edit.vue?vue&type=script&lang=js"
export * from "./invoices-edit.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__